export abstract class BaseRouterURL {
    constructor() {}
    public abstract getBaseUrls(env: any, type:any): any;
}